/**
 * @describe
 * Created by Kevin on 2020/6/30.
 */
export function pathJoin(parts, sep='/'){
  let separator = sep;
  let replace = new RegExp(separator+'{1,}', 'g');
  return parts.join(separator).replace(replace, separator);
}